// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"40a1d8f7","453":"57011d00","727":"3adb3cfb","728":"51662253","766":"d38553c2","886":"c79bbd70"}[chunkId] + ".chunk.js";
};